import {AdapterProps, FieldAdapter} from '../field-factory';
import {Radio as MantineRadio, RadioProps} from '@mantine/core';
import {FC, useContext} from 'react';
import {ReadOnlyContext} from '../readonly-context';

export type $RadioAdapterProps = AdapterProps<RadioProps>;

export const $RadioAdapter: FC<FieldAdapter<$RadioAdapterProps>> = ({
  inputProps: {disabled, onChange, ...inputProps},
  control,
}) => {
  const {
    field: {onChange: fieldOnChange, ...fieldProps},
    fieldState: {invalid},
  } = control;

  const _onChange: RadioProps['onChange'] = (value) => {
    fieldOnChange(value);
    onChange?.(value);
  };

  const {readOnly} = useContext(ReadOnlyContext);

  return (
    <MantineRadio
      error={invalid}
      disabled={disabled || readOnly}
      onChange={_onChange}
      {...fieldProps}
      {...inputProps}
    />
  );
};